export const modalModes = {
  initial: 'initial',
  error: 'error',
  cropper: 'cropper',
};

export const stateKeys = {
  modalVisible: 'modalVisible',
  modalMode: 'modalMode',
  modalModeHistory: 'modalModeHistory',
  file: 'file',
  fileSrc: 'fileSrc',
  zoom: 'zoom',
  initialCroppedArea: 'initialCroppedArea',
  errMsgs: 'errMsgs',
  crop: 'crop',
  zoom: 'zoom',
  croppedAreaPxls: 'croppedAreaPxls',
};

export const initialState = {
  [stateKeys.modalVisible]: false,
  [stateKeys.modalMode]: undefined,
  [stateKeys.modalModeHistory]: [],
  [stateKeys.errMsgs]: null,
  [stateKeys.file]: null,
  [stateKeys.fileSrc]: '',
  [stateKeys.zoom]: 1,
  [stateKeys.initialCroppedArea]: null,
  [stateKeys.croppedAreaPxls]: null,
  [stateKeys.crop]: { x: 0, y: 0 },
};
